import { useAccount, useBalance, type UseBalanceParameters } from 'wagmi';
import { useIsBlockchainVersion } from '../../hooks/useIsBlockchainVersion.ts';

type QueryConfig = UseBalanceParameters<$TSFixMe>['query'];

export const useUserBalanceBlockchainQuery = (config?: QueryConfig) => {
  const { address } = useAccount();
  const blockchainVersion = useIsBlockchainVersion();
  
  return useBalance({
    address,
    query: {
      ...config,
      enabled: config?.enabled !== false && blockchainVersion,
    },
  });
};
